var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M33.976 51H5V36.42Q5 30 11.897 30h40.206Q59 30 59 36.42V51z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 41,
  r: 3,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 41,
  r: 3,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 30.5a653 653 0 0 1 4.059-9.654C15.815 14.452 16.44 13 22.529 13H41.47c6.089 0 6.715 1.452 9.471 7.846q1.838 4.263 3.559 9.654"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M51 51v7.02M14 51v7.02"
}))));
export default SvgCarinline;